<div class="flex__container--vertical">
  @if (show.duplicate) {
    <duplicate-campaign-button
      [campaign]="campaign"
      [disabled]="disable.duplicate" />
  }

  @if (show.review) {
    <review-campaign-button
      [campaign]="campaign"
      [disabled]="disable.review" />
  }

  @if (show.edit) {
    <edit-campaign-button
      [campaign]="campaign"
      [disabled]="disable.edit" />
  }

  @if (show.remove) {
    <remove-campaign-button
      [campaign]="campaign"
      [disabled]="disable.remove" />
  }

  @if (show.sendToAdServer) {
    <send-to-ad-server-button
      [campaign]="campaign"
      [disabled]="disable.sendToAdServer" />
  }

  @if (show.stop) {
    <stop-campaign-button
      [campaign]="campaign"
      [disabled]="disable.stop" />
  }

  @if (show.cancel) {
    <cancel-campaign-button
      [campaign]="campaign"
      [disabled]="disable.cancel" />
  }

  @if (show.close) {
    <close-campaign-button
      [campaign]="campaign"
      [disabled]="disable.close" />
  }

  @if (show.proposalDownload) {
    <text-button
      icon="download"
      [disabled]="disable.proposalDownload"
      (click)="download()">
      Ladda ner offert Excel
    </text-button>
  }
</div>
